<template>
  <div class="success">
    <img src="https://xjconference.oss-cn-shenzhen.aliyuncs.com/images/404.png" />
  </div>
</template>

<script setup>

</script>

<style lang="scss">
.success {
  display: flex;
  align-items: center;
  img {
    display: block;
    width: 640px;
    margin: 0 auto
  }
}
</style>
